import { cn } from "@/lib/utils";

// Toggle switch, ported from the prototype's tc-styles.css `.switch`
// (used for deadline setup rows, tweaks, notification prefs).
export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Accessible label (the switch itself is icon-only). */
  label?: string;
  disabled?: boolean;
}

export function Switch({ checked, onChange, label, disabled }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={cn("switch", checked && "on")}
      onClick={() => onChange(!checked)}
    >
      <i />
    </button>
  );
}
